import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-rmd-cell-template',
  templateUrl: './rmd-cell-template.component.html',
  styleUrls: ['./rmd-cell-template.component.css'] // Optional: Add specific styles
})
export class RmdCellTemplateComponent {
  @Input() data: any; // The full data object
  @Input() id: any; // The ID field (investorId or accountId)
  @Input() status: any; // The status field (investorRmdStatus or accountRmdStatus)
  @Input() canEdit: boolean = false; // Determines button enablement
  @Input() debug: boolean = false; // Flag to show debugging info
  @Output() changeStatus = new EventEmitter<boolean>(); // Emits the new status
}
